import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import {
  Command,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command'
import { useState } from 'react'
import { useCalculatorStore } from '@/store/calculatorStore'
import { generate } from 'short-uuid'

const AddCourse = () => {
  const [search, setSearch] = useState('')

  const addCourse = useCalculatorStore((state) => state.addCourse)
  const addNewCourse = useCalculatorStore((state) => state.addNewCourse)
  const allCourses = useCalculatorStore((state) => state.courses)
  const show235 = useCalculatorStore((state) => state.show235)

  const includedCourses = show235
    ? allCourses.filter((course) => !course.included && course.is235course)
    : allCourses.filter((course) => !course.included)

  const availableCourses = includedCourses.filter(
    (course) =>
      !course.included &&
      course.name.toLowerCase().includes(search.toLowerCase())
  )

  const items = availableCourses.map((course) => (
    <CommandItem
      key={course.id}
      className="w-full text-left cursor-pointer text-sm p-1 rounded-sm data-[selected=true]:bg-purple-100"
      onSelect={() => {
        addCourse(course.id)
        setSearch('')
      }}
      data-testid={`course-option-${course.id}`}
    >
      {course.name}
    </CommandItem>
  ))

  if (
    search.length > 0 &&
    !availableCourses.find((c) => c.name.toLowerCase() === search.toLowerCase())
  ) {
    items.push(
      <CommandItem
        key={search}
        className="w-full text-left cursor-pointer text-sm p-1 rounded-sm data-[selected=true]:bg-purple-100"
        onSelect={() => {
          addNewCourse({
            id: generate(),
            name: search,
            hours: 0,
            sciencepoints: 0,
            mathSciencepoints: false,
            languagepoints: 0,
            grade: 0,
            numExams: 0,
            exam: 0,
            exam2: 0,
            improved: 0,
            improved2: 0,
            included: true,
            is235course: false,
            timestampAdded: Date.now(),
            hasTwoExams: false,
          })
          setSearch('')
        }}
        data-testid="add-new-course-option"
      >
        {`Legg til "${search}"`}
      </CommandItem>
    )
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          className="block w-full text-center font-bold text-sm h-14 cursor-pointer @max-[700px]:border-b @max-[700px]:border-warm-gray-600 @max-[700px]:border-dashed @min-[700px]:h-12 @min-[700px]:shadow-[0_2px_4px_0_rgba(0,0,0,0.1)] @min-[700px]:border @min-[700px]:border-warm-gray-600 @min-[700px]:rounded-md @min-[700px]:bg-white @min-[700px]:hover:bg-warm-gray-50"
          data-testid="add-course-trigger"
        >
          Legg til flere fag
        </button>
      </DialogTrigger>
      <DialogContent
        className="flex flex-col sm:w-[425px] max-h-[50vh] overflow-hidden"
        data-testid="add-course-dialog"
      >
        <DialogHeader className="p-5 pb-3">
          <DialogTitle className="text-left">Legg til flere fag</DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <Command className="overflow-hidden px-2">
          <CommandInput
            placeholder="Søk etter fag..."
            value={search}
            autoFocus
            onValueChange={(value) => setSearch(value)}
            data-testid="course-search-input"
          />
          <CommandList data-testid="course-options-list">
            <CommandGroup>{items}</CommandGroup>
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  )
}

export default AddCourse
